import _ from 'lodash'

const state = {
    fullPageApi: false,
    homePageSections: [],
    themeColor: '#ffffff',
    sectionClicked: false,
    bgColors: [
        '#f7a786',
        '#fcaa67',
        '#ba4c41',
        '#f395a4',
        '#3baff9',
        '#35975b',
        '#ffc420'
    ]
}

const getters = {
    bgColors: state => state.bgColors,
    themeColor: state => state.themeColor,
    getFullPageApi: state => state.fullPageApi,
    sectionClicked: state => state.sectionClicked,
    getHomePageSections: (state, getters) => {
        let sectionsProject = []
        getters.projectsList.forEach((project) => sectionsProject.push(project.slug))
        let routes = ['', 'about', sectionsProject, 'contact']
        return _.flatten(routes)
    },
    
}

const actions = {
    saveThemeColor({ commit }, theme) {
        commit('SET_THEME_COLOR', theme)
    },
    setFullPageApi({ commit }, fullPageApi) {
        commit('SET_FULL_PAGE_API', fullPageApi)
    },
    updateSectionClicked({ commit }, section) {
        commit('UPDATE_SECTION', section)
    }
}

const mutations = {
    ['SET_THEME_COLOR'](state, theme) {
        state.themeColor = theme
    },
    ['SET_FULL_PAGE_API'](state, fullPageApi) {
        state.fullPageApi = fullPageApi
    },
    ['UPDATE_SECTION'](state, section) {
        state.sectionClicked = section
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}